import { DatePipe } from "@angular/common";
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { AppState, DbEntityChangedEvent, ShowRequest } from "../../core";
import { AppTab } from "../../core/app-tab";
import { FesBaseComponent } from "../../shared/components/fes-base.component";
import { Volunteer } from "../models/volunteer";
import { VolunteerService } from "../services/volunteer.service";
import { VolunteerEditComponent } from "../volunteer-edit/volunteer-edit.component";
import { TableViewQueryCriteria } from "../../shared/components/table-view/table-view-component-base";

@Component({
  selector: "app-volunteer-list",
  templateUrl: "./volunteer-list.component.html",
  styleUrls: ["./volunteer-list.component.scss"],
})
export class VolunteerListComponent
  extends FesBaseComponent
  implements OnInit, OnDestroy
{
  @Input() set tabConfig(tabConfig: AppTab) {
    tabConfig.setSelected = this.onTabSelected;
  }

  @ViewChild("editTemplate", { static: true }) editTemplate: TemplateRef<any>;

  volunteers: Volunteer[] = [];
  isLoading: boolean = false;
  errorMsg: string = "";
  testOutput: any = "";
  modifiedAtDateFormat = "MMM d, y, h:mm:ss a";

  constructor(
    public appState: AppState,
    private volunteerService: VolunteerService,
    private bsModalService: BsModalService,
    private datePipe: DatePipe
  ) {
    super(appState);
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy();
  }

  async initialize() {
    this.isLoading = true;
    await this.getVolunteers();
    this.subscribe(this.appState.dbEntityChange$, (msg: DbEntityChangedEvent) => {
      if ( msg.channel === 'volunteer_change') {
        this.getVolunteers().catch((err) => {
          this.errorMsg = err;
        });
      }
    });
  }

  onTabSelected = (bSelected: boolean) => {
    if (bSelected) {
      this.initialize().catch((err) => {
        this.errorMsg = err;
      });
    } else {
      this.unsubscribe();
    }
  };

  editVolunteer(volunteer) {
    const modal = VolunteerEditComponent.showModal(this.bsModalService,volunteer);
    modal.onHidden.subscribe((data) => {
      // this.getVolunteers();
    });
  }


  showAccessiblePoints(volunteer: any) {
    const tableCriteria: TableViewQueryCriteria = {
      filters: [
        { key: "volunteerId", value: volunteer.id, mode: '=' },
        //{ key: "buildingId", value: volunteer.buildingId, mode: '=' },
      ]
    };
    const strTableCriteria = JSON.stringify(tableCriteria);
    this.appState.showView.next( new ShowRequest('tab', 'volunteer points', strTableCriteria));
  }

  async deleteVolunteer(volunteer: any) {
    this.isLoading = true;
    try {
      const deleteResult = await this.volunteerService.deleteUserById(volunteer.id);
      await this.getVolunteers();
    } catch (e: any) {
      console.error(e);
      this.appState.notifyError(this.volunteerService.extractErrorMsg(e), "APP-CHANNEL", 5);
    }
    this.isLoading = false;
  }

  async getVolunteers() {
    this.isLoading = true;
    try {
      const volunteers = await this.volunteerService.getVolunteers();
      //console.log(JSON.stringify(volunteers));
      this.volunteers = volunteers;
    } catch (e: any) {
      console.error(e);
      this.appState.notifyError(
        this.volunteerService.extractErrorMsg(e),
        "APP-CHANNEL",
        5
      )
    }
    this.isLoading = false;

  }

  modifiedAtResolver = (volunteer: Volunteer, fieldName: string): string => {
    const formatedDate = volunteer?.modifiedAt
      ? this.datePipe.transform(volunteer.modifiedAt, this.modifiedAtDateFormat)
      : "";
    return formatedDate;
  };
}
